module.exports = __webpack_public_path__ + "img/set1.57f48c5b.svg";